import { Layout, Space, Typography} from 'antd';
import React from 'react'
import { Link, Route, Switch } from 'react-router-dom';
import './App.css';
import {Navbar, News, Exchanges, CryptoDetails, Cryptocurrencies, HomePage} from './components'

function App() {
  return (
    <div className="app">
      
      <div className="navbar">
        <Navbar/>
      </div>
      <div className="main">
        <Layout>
          <div className="routes">
            <Switch>
              <Route exact path="/">
                <HomePage />
              </Route>
              <Route exact path="/exchanges">
                <Exchanges />
              </Route>
              <Route exact path="/cryptocurrencies">
                <Cryptocurrencies />
              </Route>
              <Route exact path="/crypto/:coinId">
                <CryptoDetails />
              </Route>
              <Route exact path="/news">
                <News />
              </Route>
            </Switch>
          </div>
        </Layout>
      
      <div className="footer">
        <Typography.Title level={5} style={{color: 'white', textAlign: "center" }}>
          
          Made with Love By Siddharth <br/>
          Special Mention <a href='https://www.youtube.com/c/JavaScriptMastery'>JavaScript Mastery</a><br/>
          No Rights Reserved
        </Typography.Title>
        <Space/>
        <Link to='/'>Home</Link>
        <Link to='/exchanges'>Exchanges</Link>
        <Link to='/news'>News</Link>
      </div>
      </div>
    </div>
  );
}

export default App;
